var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaterialSymbolsQrCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7717 30.6356V27.7179H22.6893V30.6356H19.7717ZM16.8541 27.7179V20.4239H19.7717V27.7179H16.8541ZM28.5246 23.3415V17.5063H31.4422V23.3415H28.5246ZM25.607 17.5063V14.5886H28.5246V17.5063H25.607ZM8.10122 20.4239V17.5063H11.0188V20.4239H8.10122ZM5.18359 17.5063V14.5886H8.10122V17.5063H5.18359ZM18.3129 7.29458V4.37695H21.2305V7.29458H18.3129ZM7.37181 10.9416H11.7482V6.56517H7.37181V10.9416ZM5.18359 13.1298V4.37695H13.9365V13.1298H5.18359ZM7.37181 28.4473H11.7482V24.0709H7.37181V28.4473ZM5.18359 30.6356V21.8827H13.9365V30.6356H5.18359ZM24.8775 10.9416H29.254V6.56517H24.8775V10.9416ZM22.6893 13.1298V4.37695H31.4422V13.1298H22.6893ZM25.607 30.6356V26.2591H22.6893V23.3415H28.5246V27.7179H31.4422V30.6356H25.607ZM19.7717 20.4239V17.5063H25.607V20.4239H19.7717ZM13.9365 20.4239V17.5063H11.0188V14.5886H19.7717V17.5063H16.8541V20.4239H13.9365ZM15.3953 13.1298V7.29458H18.3129V10.2122H21.2305V13.1298H15.3953ZM8.46592 9.8475V7.65928H10.6541V9.8475H8.46592ZM8.46592 27.3532V25.165H10.6541V27.3532H8.46592ZM25.9717 9.8475V7.65928H28.1599V9.8475H25.9717Z",
    fill: "#B5B8C5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialSymbolsQrCode);
export default __webpack_public_path__ + "static/media/material-symbols_qr-code.7db334674b674430a7166b139585a263.svg";
export { ForwardRef as ReactComponent };